var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "0abafa30-0c14-4912-9746-7432024055fb",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "9caa7b73-ff8e-47c3-b08b-86dafb15cafa",
    "data-name": "copy",
    className: "symbol"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5,20A1.5,1.5,0,0,1,7,18.5V6H1.75A0.75,0.75,0,0,0,1,6.75V22.5A1.5,1.5,0,0,0,2.5,24h12A1.5,1.5,0,0,0,16,22.5V20H8.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "19.5 4.5 24 4.5 19.5 0 19.5 4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,6V0H9.75A0.75,0.75,0,0,0,9,.75V16.5A1.5,1.5,0,0,0,10.5,18h12A1.5,1.5,0,0,0,24,16.5V6H18Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCopy);
export default __webpack_public_path__ + "static/media/ico-copy.ea508ecc.svg";
export { ForwardRef as ReactComponent };